export default {
  results: [],
  columns: [],
  headerColumns: [],
  parameters: {},
  selectedInstalledSoftware: [],
  isSelectAllChecked: false
};
